import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { GroupId, InputAttribute } from 'src/app/app.model';
import { NS_AvailableTablesList } from '../../../namespaces';

@Component({
    selector: 'available-tables-list',
    templateUrl: './available-tables-list.html',
    styleUrls:['./available-tables-list.scss']
})

export class AvailableTablesListComponent implements OnInit, OnDestroy {

    @Input() selectedDatasource: any;
    @Input() isTemplateAttachedToSource: boolean;
    @Input() inputAttribute:any;
    @Input() addButtonDisableMessageMap:  Map<string, string>;

    @Output() onCheckBoxChangeEvent: EventEmitter<NS_AvailableTablesList.onCheckBoxChangedEvent> = new EventEmitter<NS_AvailableTablesList.onCheckBoxChangedEvent>();
    constructor() { }

    ngOnInit() { }

    onCheckBoxChanged(inputAttribute, pValue, filter, triggerNotification, idx){
        this.onCheckBoxChangeEvent.emit({inputAttribute:inputAttribute, pValue: pValue, filter:filter, triggerNotification:triggerNotification, idx:idx})
    }

    ngOnDestroy(){
        this.onCheckBoxChangeEvent.unsubscribe();
    }
}

